<template>
  <div
    class="row"
    v-if="entidad_data.inspecciones && entidad_data.inspecciones.length"
  >
    <table class="table table-sm table-hover" style="font-size: 0.85em;">
      <thead class="thead-dark">
        <tr class="text-center">
          <th>Número</th>
          <th>Punto Gestión</th>
          <th>Formato Inspección</th>
          <th>Fecha</th>
          <th>Estado</th>
          <th>Estado Documento</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in entidad_data.inspecciones" :key="index">
          <th class="text-center">
            <button
              type="button"
              class="btn btn-sm btn-default py-0"
              @click="edit(item.id)"
            >
              {{ item.id }}
            </button>
          </th>
          <td>{{ item.sitio ? item.sitio.nombre : "" }}</td>
          <td>{{ item.formato_inspeccion.nombre }}</td>
          <td>{{ item.fecha_inicio }}</td>
          <td class="text-center">
            <span
              :class="
                item.estado == 1
                  ? 'badge badge-secondary'
                  : item.estado == 2 || item.estado == 3
                  ? 'badge badge-success'
                  : 'badge badge-danger'
              "
            >
              {{ item.nEstado }}
            </span>
          </td>
          <td class="text-center">
            <span
              :class="
                item.estado_documento == 1
                  ? 'badge badge-warning'
                  : item.estado_documento == 2
                  ? 'badge badge-success'
                  : 'badge badge-danger'
              "
            >
              {{ item.nEstadoDocumento }}
            </span>
          </td>
          <td class="text-right">
            <div class="btn-group text-center" v-if="item.link">
              <a target="_blank" class="btn btn-info btn-sm" :href="item.link"
                ><i class="fa fa-download"></i
              ></a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row" v-else>
    <div class="alert alert-warning col-md-12">
      <h5><i class="icon fas fa-exclamation-triangle"></i> Atención!</h5>
      No se realizaron Inspecciones a esta Entidad!
    </div>
  </div>
</template>

<script>
export default {
  name: "GestionInfoInspeccionesHidrocarburos",

  data() {
    return {};
  },
  methods: {
    edit(inspeccion_id) {
      this.$parent.$refs.closeModal.click();
      this.$store.dispatch("getMenus", 2);
      this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
        },
      });
    },

    permisoLineaNegocio(linea_negocio) {
      let lineasUser = this.$store.state.user.lineas_negocio;
      return (
        lineasUser.find((linea) => linea.id === linea_negocio) !== undefined
      );
    },
  },

  props: {
    entidad_data: {
      type: Object,
    },
    type_entidad: {
      type: String,
    },
  },
};
</script>
